import {
  type CreditMovieCast,
  type CreditMovieCrew,
  type CreditTvCast,
  type CreditTvCrew,
} from '@tmdb-graphql-api/schema/types';
import { type Credit } from '../types.ts';

export const isMovieCredit = (data: Credit): data is CreditMovieCast | CreditMovieCrew =>
  data.__typename === 'CreditMovieCast' || data.__typename === 'CreditMovieCrew';

export const isCastCredit = (credit?: Credit, subTypeKey?: 'cast' | 'crew'): credit is CreditMovieCast | CreditTvCast =>
  !!credit && subTypeKey === 'cast';

export const isCrewCredit = (credit?: Credit, subTypeKey?: 'cast' | 'crew'): credit is CreditMovieCrew | CreditTvCrew =>
  !!credit && subTypeKey === 'crew';
